module.exports = __webpack_public_path__ + "img/IT-consulting-center.16681007.png";